import * as React from 'react';

import { FormattedMessage, useIntl } from 'react-intl';
import { Outlet } from 'react-router-dom';

import MainLayout from 'src/components/layout/MainLayout';
import { PERMISSION } from 'src/features/auth';
import { entityMessages } from 'src/features/entity/utils/messages';
import { PATH } from 'src/features/navigation/utils/constants';
import { pageTitles } from 'src/features/navigation/utils/messages';
import useHasPermissions from 'src/hooks/useHasPermissions';
import Tab from 'src/registry/components/navigation/Tab';
import TabRow from 'src/registry/components/navigation/TabRow';
import { useTitleStore } from 'src/stores/useTitleStore';

const EntitiesLayout = () => {
    const { formatMessage } = useIntl();
    const permissionAccessEntities = useHasPermissions([PERMISSION.ACCESS_ENTITIES]);

    const { setTitle, removeTitle } = useTitleStore();

    React.useEffect(() => {
        setTitle(formatMessage(pageTitles.entitiesCRM));
        return removeTitle;
    }, [formatMessage, removeTitle, setTitle]);

    return (
        <MainLayout>
            {permissionAccessEntities && (
                <TabRow>
                    <Tab to={`/${PATH.ENTITIES}/people`}>
                        <FormattedMessage {...entityMessages.people} />
                    </Tab>
                    <Tab to={`/${PATH.ENTITIES}/organisations`}>
                        <FormattedMessage {...entityMessages.groups} />
                    </Tab>
                </TabRow>
            )}
            <Outlet />
        </MainLayout>
    );
};

export default EntitiesLayout;
